// @aide-description Manage the roles that grant portal users their permissions, and see how many users hold each one
import React from "react";
import { ListRoles } from "features/Admin";
import { PageHeader } from "@redriver/cinnamon";
import { AppPageContent } from "components/pages";

const RoleListPage = () => (
  <AppPageContent>
    <PageHeader>Roles</PageHeader>
    <ListRoles />
  </AppPageContent>
);

export default RoleListPage;
